export const qk = {
  profile: ["user", "profile"] as const,
  chatsAll: ["chats", "list"] as const,
  chats: (limit: number, archived?: boolean) => ["chats", "list", limit, archived ?? false] as const,
  chat: (chatId: string) => ["chats", "detail", chatId] as const,
  projects: ["projects", "list"] as const,
  projectsByOrg: (orgId: string) => ["projects", "list", "org", orgId] as const,
  project: (id: string) => ["projects", "detail", id] as const,
  projectChats: (id: string) => ["projects", id, "chats"] as const,
  documentChats: (id: string) => ["documents", id, "chats"] as const,
  orgs: ["orgs", "list"] as const,
  org: (id: string) => ["orgs", "detail", id] as const,
  orgMembers: (id: string) => ["orgs", id, "members"] as const,
  standaloneDocs: ["documents", "standalone"] as const,
};
